import { DocumentObserver } from "@hotelchamp/common";

export const documentObserver = new DocumentObserver();
